import request, { get, post } from '../request';

async function upload({ saleId, file, accessToken }) {
  var credentials = await get(
    saleId
      ? `/api/v1/uploads/sign?saleId=${saleId}`
      : '/api/v1/uploads/sign/general',
    accessToken
  );

  var data = new FormData();
  for (var k in credentials.data) {
    data.append(k, credentials.data[k]);
  }

  data.append('file', file);

  const options = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
    },
    body: data,
  };

  var result = await request(credentials.url, options);
  return {
    id: `v${result.version}/${result.public_id}`,
    originalFilename: `${result.original_filename}.${result.format}`,
    url: result.secure_url,
    full: result.original_filename,
    type: result.original_filename,
    details: null,
    uploadedAt: result.created_at,
    metadata: {
      deleteToken: result.delete_token,
    },
  };
}

async function remove({ saleId, deleteToken, accessToken }) {
  var credentials = await get(
    saleId
      ? `/api/v1/uploads/sign?saleId=${saleId}`
      : '/api/v1/uploads/sign/general',
    accessToken
  );

  await post(credentials.deleteUrl, { token: deleteToken });
}

export { upload, remove };



// WEBPACK FOOTER //
// ./src/app/services/cloudinary/index.js